import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Raven from 'raven-js';
import { Component } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultFallback = () => {
  return /*#__PURE__*/_jsx(Text, {
    color: "text-alert-default",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "developer-experience-shared-components.error"
    })
  });
};
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.reset = () => {
      this.setState({
        hasError: false,
        error: undefined
      });
    };
    this.state = {
      hasError: false
    };
  }
  componentDidCatch(error, errorInfo) {
    this.setState({
      hasError: true,
      error
    });
    Raven.captureException(error, {
      extra: {
        error,
        errorInfo,
        message: 'ErrorBoundary caught an error'
      }
    });
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    if (this.props.onError) {
      this.props.onError(error, errorInfo);
    }
  }
  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }
      if (this.props.renderFallback) {
        return this.props.renderFallback(this.state.error, this.reset);
      }
      return /*#__PURE__*/_jsx(DefaultFallback, {});
    }
    return this.props.children;
  }
}
export default ErrorBoundary;